export default {
  readon: 'Read On',
  learnmore: 'Learn More',
  submit: 'submit',
  filter: 'Filter Results',
  cancel: 'Cancel',
  apply: 'apply',
  compver: 'Compare Versions',
  show: 'Display',
  back: 'Back to ',
  prev_page: 'Previous page',
  all: 'All ',
  close: 'close',
  goto: 'Go To ',
  howto: 'Using ',
  print: 'Print Page',
  advagain: 'Adv Search',
  use: 'Perform ',
  togglehl: 'Toggle Highlight',
  next: 'Next',
  prev: 'Prev',
  collapse: 'collapse',
  showall: 'show all',
  checkcontent: 'Show all',
  showless: 'show less',
  shortcut: 'Quick Links',
  search: 'Search',
  contactus: 'Contact Us',
  donate: 'Donate',
  feedback: 'Feedback',
  selectall: "Select All",
  deselect: "Clear All",
  reset_form: "Reset Form",
  case_showalltitle: 'Show All Titles',
  case_collapsetitle: 'Collapse Titles',
  ft_support: 'Support Us',
  ft_legal: 'Legal',
  ft_link: 'Links',
  ft_disclaimer: 'Disclaimer',
  ft_donors: 'Donors',
  ft_home: 'Home',
  hd_liis: 'Other LIIs',
  classic: 'Classic',
  news: 'New Features',
  newfeature: 'NEW',
}